/**
 * Este archivo contiene algunas abreviaciones de los estilos usados en ExcelJs.
 * Esto se hace con el objetivo de no repetir tanto los estilos y estandarizar
 * mejor los reportes.
 */

// 1. Estilos generales
export const SIZE_12 = { size: 12 };
export const SIZE_13 = { size: 13 };
export const SIZE_14 = { size: 14 };

export const ALIGN_CENTER = { vertical: 'middle', horizontal: 'center' };
export const ALIGN_LEFT = { vertical: 'middle', horizontal: 'left' };
export const ALIGN_RIGHT = { vertical: 'middle', horizontal: 'right' };

export const BORDER_CELL = {
  top: { style: 'thin' },
  left: { style: 'thin' },
  bottom: { style: 'thin' },
  right: { style: 'thin' },
};

// 2. Tablas

// 2.1 Títulos de las tablas
export const BG_CELL_TITLE = {
  type: 'pattern',
  pattern: 'solid',
  fgColor: { argb: 'd9d9d9' },
};
export const FONT_TITLE = { size: 12, bold: true };
export const STYLE_TITLE_TABLE = {
  font: FONT_TITLE,
  alignment: ALIGN_CENTER,
  fill: BG_CELL_TITLE,
  border: BORDER_CELL,
};

// 2.2 Registros de las columnas de las tablas
export const TITLE_CENTER = {
  style: { font: SIZE_12, alignment: ALIGN_CENTER },
};
export const TITLE_LEFT = { style: { font: SIZE_12, alignment: ALIGN_LEFT } };
export const TITLE_RIGHT = { style: { font: SIZE_12, alignment: ALIGN_RIGHT } };

// 2.3 Formatos de colmunas
export const COLUMN_MONEY = { ...TITLE_RIGHT, t: 'money' };
export const COLUMN_MONEY_20 = { width: 20, ...COLUMN_MONEY };
export const COLUMN_MONEY_25 = { width: 25, ...COLUMN_MONEY };
export const COLUMN_NUMBER = { ...TITLE_CENTER, t: 'number' };
export const COLUMN_NUMBER_MIL = { ...TITLE_CENTER, t: 'numeroConMiles' };

// 2.4 Totales de la tabla
export const TOTALS_STYLE = {
  font: FONT_TITLE,
  border: BORDER_CELL,
  fill: BG_CELL_TITLE,
};
